$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  if (p === 'organizer_product_category_link' && a === 'list') {
    let product_category_link_register_ajax_lock = false;

    $(document).on(
      'click',
      '#product-category-link-register-button',
      function () {
        let productCategoryId = $(this).attr('data-product-category-id');
        let productId = $("select[name='product_id'] option:selected").val();
        let locationId = $('body').attr('event_id');
        let backgroundColor = $(this).attr('data-background-color');

        if (!product_category_link_register_ajax_lock) {
          product_category_link_register_ajax_lock = true;

          const disabledOnClick = $('#product-category-link-register-button');
          const btnWidth = disabledOnClick.outerWidth();
          disabledOnClick.css('width', btnWidth + 'px');
          disabledOnClick.prop('disabled', true);
          disabledOnClick.html(
            '<i class="spinner-border spinner-border-sm"></i>'
          );

          $.ajax({
            type: 'POST',
            url: '/ajax/organizer_product_category_link/new',
            data: {
              product_category_id: productCategoryId,
              product_id: productId,
              location_id: locationId,
              background_color: backgroundColor,
            },
          })
            .done(function (data) {
              disabledOnClick.prop('disabled', false);
              disabledOnClick.html('Legg til produkt');

              if (data.html !== undefined && data.html !== null) {
                $("select[name='product_id'] option:selected").remove();
                $('#product-category-link-list-sortable').empty();
                $('#product-category-link-list-sortable').append(data.html);
                popupAlert();
              }
            })
            .fail(function (data) {
              if (
                data.responseJSON.redirect_url !== undefined &&
                data.responseJSON.redirect_url !== null
              ) {
                document.location.href = data.responseJSON.redirect_url;
              }

              product_category_link_register_ajax_lock = false;
            })
            .always(function () {
              product_category_link_register_ajax_lock = false;
            });
        }
      }
    );
  }
});
